import React from 'react'
import { AccordionItem, AccordionHeader, AccordionPanel, makeStyles, tokens, Text, mergeClasses } from '@fluentui/react-components'
import { Grid } from '../../common/grid/Grid'
import { GridItem } from '../../common/grid/GridItem'
import { Modules } from '../../../api/schemas/schema'
import { t } from 'i18next'
import { getModuleName, getModuleType } from '../../../helpers/subscriptionHelper'

const useStyles = makeStyles({
   moduleBox: {
      display: 'flex',
      alignItems: 'center',
      padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
      backgroundColor: tokens.colorNeutralBackground2,
      borderRadius: tokens.borderRadiusMedium,
      border: `1px solid ${tokens.colorNeutralStroke2}`,
      height: '100%',
      boxSizing: 'border-box',
   },
   marginTop: {
      marginTop: tokens.spacingVerticalS,
   },
   accordionItem: {
      borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
      '&:last-child': {
         borderBottom: 'none',
      },
   },
   gridGap: {
      paddingTop: tokens.spacingVerticalM,
      paddingBottom: tokens.spacingVerticalM,
   }
})

type SubscriptionAccordionItemProps = {
   title: string
   enumOptions: any
   filteredModules: Modules[]
   value: string
   className?: string
}

export const SubscriptionAccordionItem = ({
   title,
   enumOptions,
   filteredModules,
   className,
   value,
}: SubscriptionAccordionItemProps) => {
   const classes = useStyles()
   const existingModules = filteredModules || []

   return (
      existingModules.length > 0 && (
         <AccordionItem value={value} className={mergeClasses(classes.accordionItem, className)}>
            <AccordionHeader className={classes.marginTop}>
               <Text size={400} weight="semibold">
                  {title}
               </Text>
            </AccordionHeader>
            <AccordionPanel>
               <Grid className={classes.gridGap} gap="M">
                  {existingModules.map((module, i) => {
                     const moduleType = getModuleType(module)
                     if (!moduleType) return null

                     return (
                        <GridItem size="6/12" key={i}>
                           <div className={classes.moduleBox}>
                              <Text size={300} weight="medium">
                                 {t(`${getModuleName(module, enumOptions)}`)}
                              </Text>
                           </div>
                        </GridItem>
                     )
                  })}
               </Grid>
            </AccordionPanel>
         </AccordionItem>
      )
   )
}
